import React from 'react';

//TODO move to ticker hover package
export const getColorByValue = (theme: any, value: number | string): React.CSSProperties['color'] => {
  if (value) {
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value)))) {
      const result = +value >= 0 ? theme.colorPalette.green500 : theme.colorPalette.red500;
      return result;
    }
  }
  return theme.colors.foreground;
};

export const getClassnameByValue = (value: number): string => {
  if (isNaN(value)) return '';
  if (value > 0) return 'green';
  else if (value < 1) return 'red';
  else return '';
};

export const getColorClassnameByValue = (value: number) => {
  if (value > 0) return 'green';
  else if (value < 0) return 'red';
  else return 'black';
};
